/**
 * The connectivity banner. Above everything, because a salesperson needs to know before they
 * take the money, not after.
 *
 * It never blocks: the catalogue is cached and a sale queues, so offline is a state the app
 * works in rather than an error it stops at.
 */

import { useSyncExternalStore } from 'react';

import {
  getOnlineServerSnapshot,
  getOnlineSnapshot,
  subscribeToOnline,
} from '@/shared/lib/online';

export function OfflineBanner() {
  const online = useSyncExternalStore(subscribeToOnline, getOnlineSnapshot, getOnlineServerSnapshot);

  if (online) return null;

  return (
    <div
      role="status"
      className="flex items-center gap-2 bg-warning-subtle px-4 py-2 text-sm font-semibold text-warning-subtle-text"
      data-print="hide"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 18h.01M5 12.5a9.9 9.9 0 0 1 14 0M2 9a14 14 0 0 1 20 0M8.5 16a5.5 5.5 0 0 1 7 0"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path d="m3 3 18 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
      Offline — you can still sell. Sales send when the connection is back.
    </div>
  );
}
